import React from 'react';

import {FeatureFlagEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ViewCourseSessionRecord} from 'src/pages/Modules/Training/shared/ViewCourseSessionRecord/ViewCourseSessionRecord';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const CourseSessionRecordPage: React.FC = () => {
  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Training}>
      <ViewCourseSessionRecord isAdminPath={false} />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.TrainingSessionRecord(':sessionId', ':view'),
  element: <CourseSessionRecordPage />,
  isPrivate: true,
});
